// extracted by mini-css-extract-plugin
module.exports = {"root":"lIbR1y7GTAvVfYX3mG0Ry","courseNumberInput":"_2jkpUvWYGZytKOIw2jrvlW"};